// extracted by mini-css-extract-plugin
export default {"root":"ButtonGroup_root__1HpWR"};